"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFinStart = void 0;
var tslib_1 = require("tslib");
var use_fin_event_1 = require("./use-fin-event");
function useFinStart() {
    var _a = (0, use_fin_event_1.useFinEvent)(), triggerEvent = _a[0], registerHandler = _a[1];
    var triggerStartEvent = function (params) { return triggerEvent('start', tslib_1.__assign({}, params)); };
    var registerStartHandler = function (handler) { return registerHandler('start', handler); };
    return [triggerStartEvent, registerStartHandler];
}
exports.useFinStart = useFinStart;
//# sourceMappingURL=use-fin-start.js.map